module.exports = __webpack_public_path__ + "static/placeholder-30671817cb617b7cab3b81d862b3d9c3.jpg";